// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphLogoStrip.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphLogoStrip.tsx");
  import.meta.hot.lastModified = "1732036225886.4712";
}
// REMIX HMR END

import { Image } from "@unpic/react";
import { Link } from "@remix-run/react";
import { generate } from "randomstring";
import Heading from "../Heading";
export default function LogoStrip({
  items,
  title
}) {
  return <li className="p-6 flex flex-col gap-4 items-center border-gradient-secondary shadow-primary-700 rounded-[20px] bg-primary-700">
      <Heading tag="h3" className="!text-neutral-100">{title}</Heading>
      <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-20 gap-y-8">
        {items?.map(item => <Link key={generate({
        length: 5,
        charset: "alphanumeric"
      })} to={item.ctaSingle ? item.ctaSingle.url : ""} target="_blank">
            <Image width={item.image?.mediaImage.width} height={item.image?.mediaImage.height} className="object-scale-down max-w-[100px]" src={item.image.mediaImage.url} alt={item.image?.mediaImage.alt} />
          </Link>)}
      </div>
    </li>;
}
_c = LogoStrip;
var _c;
$RefreshReg$(_c, "LogoStrip");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;